<script setup lang="ts">
import Container from '@/layouts/Container.vue';
import FileUploadForm from '../components/upload/FileUploadForm.vue';

definePage({
  name: 'upload',
});
</script>

<template>
  <Container>
    <template #title>
      Upload Session Data
    </template>

    <FileUploadForm />
  </Container>
</template>

<style scoped>
.upload-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
